import React from 'react';

const NotFound = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(70vh)'
    }}
    >
        We can&apos;t find the page you are looking for... 😕
    </div>
);

export default NotFound;
